import glassReplacementImg from "@/assets/service-glass-replacement.webp";

export interface ServiceData {
  slug: string;
  title: string;
  subtitle: string;
  price: string;
  image: string;
  cardImage: string;
  description: string;
  features: string[];
  process: { step: string; desc: string }[];
}

const SUPABASE_RENDER =
  "https://sbdjxsxpkgngbkdabugx.supabase.co/storage/v1/render/image/public/client-media/inka-glass-llc/images";

export const services: ServiceData[] = [
  {
    slug: "window-replacement",
    title: "Window Replacement",
    subtitle: "New & replacement windows for homes and businesses",
    price: "Free Estimate",
    image: `${SUPABASE_RENDER}/1781792997946-465-34939.jpg?width=1200&height=900&resize=cover&quality=60`,
    cardImage: `${SUPABASE_RENDER}/1781792997946-465-34939.jpg?width=640&height=480&resize=cover&quality=58`,
    description:
      "Professional window replacement across Houston and the surrounding areas. Whether your windows are drafty, damaged, hard to open, or just outdated, Inka Glass installs energy-efficient replacement windows built for the Texas climate. We handle single-hung, double-hung, sliding, picture, and custom windows for both homes and commercial properties — measured precisely and installed clean.",
    features: [
      "Energy-efficient double-pane & Low-E windows",
      "Single-hung, double-hung, sliding & picture windows",
      "Storm-rated and impact-resistant options",
      "Residential & commercial installations",
      "Precise measuring for a weather-tight fit",
      "Free, no-pressure written estimates",
    ],
    process: [
      { step: "Consultation", desc: "We assess your existing windows, openings, and goals — efficiency, security, or looks." },
      { step: "Measure & Quote", desc: "Exact measurements and a clear, flat written estimate with no hidden fees." },
      { step: "Installation", desc: "Clean, professional removal and install with proper sealing and insulation." },
      { step: "Final Walkthrough", desc: "We test every window and confirm a smooth, weather-tight finish with you." },
    ],
  },
  {
    slug: "glass-replacement",
    title: "Glass Replacement",
    subtitle: "Broken, foggy & custom glass replaced",
    price: "Free Estimate",
    image: glassReplacementImg,
    cardImage: glassReplacementImg,
    description:
      "Fast, reliable glass replacement for Houston homes and businesses. From a single cracked pane to foggy double-pane insulated glass units, storefront glass, shower doors, tabletops, and mirrors — Inka Glass cuts and fits new glass to your exact specifications. We restore clarity, safety, and energy efficiency without the cost of replacing the whole window frame.",
    features: [
      "Broken & cracked glass pane replacement",
      "Foggy / failed double-pane (IGU) replacement",
      "Storefront & commercial glass",
      "Shower doors, tabletops & custom mirrors",
      "Tempered & safety glass available",
      "Same-quality glass matched to your opening",
    ],
    process: [
      { step: "Assessment", desc: "We identify the glass type, thickness, and size you need — and any safety requirements." },
      { step: "Precise Measure", desc: "Your opening is measured exactly so the new glass fits perfectly the first time." },
      { step: "Custom Cut", desc: "New glass is cut and prepared to match your specifications." },
      { step: "Clean Install", desc: "We fit, seal, and clean up — leaving your glass crystal clear and secure." },
    ],
  },
];
